import { createMachine } from 'xstate';
import { Order } from '../gql/graphql';

// This machine isn't used and it probably should be. The states and path already exist, but the path that should navigate here instead goes to existingApplication.virtualCard

export default createMachine(
  {
    id: 'VirtualCard',
    initial: 'Loading',
    context: {
      order: null,
    },
    states: {
      Loading: {
        // TODO: Should go to cart summary if resuming (has items in cart)
        // TODO: Should go to contract summary if docs_ready
        always: [
          {
            target: 'ContractSummary',
            cond: 'DocsReady',
          },
          {
            target: 'ItemEntry',
          },
        ],
      },
      ItemEntry: {
        on: {
          CANCEL: {
            target: 'CartSummary',
          },
          CONFIRM_ADD_ITEM: {
            target: 'CartSummary',
          },
        },
      },
      CartSummary: {
        on: {
          ADD_ITEM: {
            target: 'ItemEntry',
          },
          CONFIRM_ITEMS: {
            target: 'CartTotal',
          },
        },
      },
      CartTotal: {
        on: {
          BACK: {
            target: 'CartSummary',
          },
          CONFIRM_TOTAL: {
            target: 'ContractSummary',
          },
        },
      },
      ContractSummary: {
        on: {
          CONTINUE: {
            target: 'LeaseAgreement',
          },
          BACK: {
            target: 'CartSummary',
          },
        },
      },
      LeaseAgreement: {
        on: {
          BACK: {
            target: 'ContractSummary',
          },
          SIGN: {
            target: 'VirtualCardPage',
          },
        },
      },
      VirtualCardPage: {},
    },
    schema: {
      context: {} as { order: Order | null },
      events: {} as
        | { type: 'CANCEL' }
        | { type: 'CONFIRM_ADD_ITEM' }
        | { type: 'ADD_ITEM' }
        | { type: 'CONFIRM_ITEMS' }
        | { type: 'BACK' }
        | { type: 'CONFIRM_TOTAL' }
        | { type: 'CONTINUE' }
        | { type: 'SIGN' },
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
  },

  {
    actions: {
      ItemEntryTestPrep: (context, event) => null,
    },
    guards: {
      DocsReady: (context, event) => context?.order?.application?.lease?.status === 'docsReady',
    },
  },
);
